import { render, staticRenderFns } from "./Detail-Product.vue?vue&type=template&id=7da9a925"
import script from "./Detail-Product.vue?vue&type=script&lang=js"
export * from "./Detail-Product.vue?vue&type=script&lang=js"
import style0 from "./Detail-Product.vue?vue&type=style&index=0&id=7da9a925&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports